
export const MIN_MAX_SIO = {
    PORT_NUMBER: { start: 0, end: 3 }
}

export const DEVICE_TYPE = {
    DEVICE_196: {
        id: 196,
        name: 'X1100',
    },
    DEVICE_193: {
        id: 193,
        name: 'X100'
    }
}

export const SIOS_TYPE = {
    PORT_1: {
        type: DEVICE_TYPE.DEVICE_193.id,
        id: 1,
        name: 'port_1'
    },
    PORT_2: {
        type: DEVICE_TYPE.DEVICE_193.id,
        id: 2,
        name: 'port_2'
    },
    INTERNAL: {
        type: DEVICE_TYPE.DEVICE_196.id,
        id: 3,
        name: 'internal'
    }
}

export const SIOS_DATA = {
    hidId: null,
    name: null,
    deviceType: null,
    sioType: null,
    portNumber: null,
    toAddEdit: function (controllerId) {
        return {
            hidId: controllerId != null && typeof controllerId != 'undefined' ? controllerId : this.hidId,
            name: this.name,
            deviceType: this.deviceType,
            sioType: this.sioType,
            portNumber: this.portNumber
        }
    },
    isValid: function () {
        return this.name != null && this.name !== ''
            && this.deviceType != null && this.sioType != null
            && this.hidId != null &&
            this.portNumber != null && this.portNumber !== '' ;
    }
}
